import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import ReactCodeInput from "react-code-input";
import appcolors from "../../constants/Colors";
import GlobalButton from "../CustomButton";
import Label from "../Label";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
    padding: "20px 0",
  },
}));

const props = {
  inputStyle: {
    fontFamily: "Inter",
    // margin: "10px",
    MozAppearance: "textfield",
    width: "40px",
    borderRadius: "2px",
    fontSize: "14px",
    height: "45px",
    textAlign: "center",
    color: appcolors.black,
    border: `1px solid ${appcolors.slateGrey}`,
  },
};

let paramsData = {};

const VerificationDialog = forwardRef(({ openSuccessDialog }, ref) => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const handleVerifyCode = () => {
    handleClose();
    openSuccessDialog.current.isVisible();
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <Stack p={2} textAlign={"center"}>
        <DialogTitle
          variant="h1"
          fontWeight={700}
          fontSize={"1.5rem"}
          fontFamily={"inter"}
          id="customized-dialog-title"
        >
          {t("verificationProcess")}
        </DialogTitle>
        <Typography variant="body2" color={appcolors.slateGrey}>
          {t("enterVerificationCode", {
            codeNumber: 6,
          })}
        </Typography>
      </Stack>
      <DialogContent>
        <Container maxWidth="xs">
          <Box my={4} className={"react-cvi"}>
            <Label labelText={`${t("enter")} 6 ${t("digitCode")}`} required />
            <ReactCodeInput
              type="number"
              value={code}
              onChange={(e) => {
                setCode(e);
              }}
              fields={6}
              {...props}
            />
          </Box>
        </Container>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          btnText={"submit"}
          styleProps={{ width: 150, height: 40 }}
          handleClickBtn={handleVerifyCode}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default VerificationDialog;
